var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefcase3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.24998 3.75V6H3.99998C2.91532 6 2.03232 6.86344 2.00085 7.94048L3.58282 9.21929C5.77292 10.9897 8.45227 12.0347 11.25 12.2208V11C11.25 10.5858 11.5858 10.25 12 10.25C12.4142 10.25 12.75 10.5858 12.75 11V12.2208C15.5477 12.0347 18.2271 10.9897 20.4172 9.21929L21.9991 7.94048C21.9677 6.86344 21.0847 6 20 6H16.75V3.75C16.75 2.7835 15.9665 2 15 2H8.99998C8.03348 2 7.24998 2.7835 7.24998 3.75ZM8.99998 3.5H15C15.1381 3.5 15.25 3.61193 15.25 3.75V6H8.74998V3.75C8.74998 3.61193 8.86191 3.5 8.99998 3.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 9.86858L21.3601 10.3858C18.9032 12.372 15.8914 13.5356 12.75 13.7237V15C12.75 15.4142 12.4142 15.75 12 15.75C11.5858 15.75 11.25 15.4142 11.25 15V13.7237C8.10857 13.5356 5.09684 12.372 2.63986 10.3858L2 9.86858V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V9.86858Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase3);
export default __webpack_public_path__ + "static/media/briefcase-3.0a819945d0770b439df58c78a7fcea0e.svg";
export { ForwardRef as ReactComponent };